import Head from 'next/head'
import { Element } from 'react-scroll'

import TopicNewestList from 'app/PelatihanMandiriPage/partials/Topic/TopicNewestList'
import TopicRecommendationList from 'app/PelatihanMandiriPage/partials/Topic/TopicRecommendationList'
import TopicProgress from 'app/PelatihanMandiriPage/partials/Topic/TopicProgress'
import TopicWebinar from 'app/PelatihanMandiriPage/partials/Topic/Webinar'
import TopicMore from 'app/PelatihanMandiriPage/partials/Topic/TopicMore'
import TabbedNav from '../TabbedNav'
import {
  useTopicNewest,
  useTopicRecommendation,
  useTopicProgress,
} from 'api/microlearning/useAPITopics'
import { useSETrackerEvent } from 'app/PelatihanMandiriPage/hooks/useSETrackEvent'
import useTopicSurveyBanner from 'app/PelatihanMandiriPage/hooks/useTopicSurveyBanner'
import { MILKvKeys, useGetKeyPairValue } from 'api/microlearning/useAPIKeyValue'

type forYouProps = {
  isDesktop: boolean
}

const ForYouRevamp = ({ isDesktop }: forYouProps) => {
  const { SETrackTopNav } = useSETrackerEvent()

  const topicSurveyBanner = useTopicSurveyBanner()
  const getTopicNewest = useTopicNewest()
  const getTopicRecommendation = useTopicRecommendation()
  const getTopicProgress = useTopicProgress()
  const getWebinar = useGetKeyPairValue(MILKvKeys.WebinarEntries)

  const handleScrollClicked = ({ label }) => {
    SETrackTopNav({
      action_type: 'click_top_nav',
      action_value: label,
    })
  }

  /* FOR PROGRESS TOPIC */
  // first we sorting percentage progress highest to lowest
  const sortedProgress = getTopicProgress?.data?.data?.sort(
    (a, b) => b.percentage - a.percentage
  )

  // we get the first progress that has percentage 100 and aksi nyata state is NOT_CREATED, NEED_REVISION, CONFIRMED, CREATED
  const selectedProgress =
    sortedProgress?.find(
      (item) =>
        item.percentage === 100 &&
        ['NOT_CREATED', 'CONFIRMED', 'CREATED', 'NEED_REVISION'].includes(
          item.aksiNyata.state
        )
    ) ||
    sortedProgress?.find(
      (item) =>
        item.percentage < 100 &&
        item.percentage > 1 &&
        item.modules.find(
          (module) =>
            module.postTest === false && module.prerequisiteCompleted === true
        )
    )

  return (
    <>
      <Head>
        <title>Pelatihan Mandiri | Untuk Anda</title>
      </Head>
      {!isDesktop && (
        <TabbedNav
          activeMenu="untuk-anda"
          scrollClicked={handleScrollClicked}
        />
      )}
      <div
        className="bg-gray-10"
        style={{
          minHeight: 'calc(100vh - 3.5rem)',
        }}
      >
        <div className={isDesktop ? 'px-3 pb-5' : 'px-3 pb-5 pt-40'}>
          {topicSurveyBanner(getTopicProgress?.data?.data, {
            className: 'my-6 first:mt-0',
          })}

          <div className="mb-6">
            <TopicNewestList
              isLoading={getTopicNewest.isLoading}
              items={getTopicNewest?.data?.data || []}
            />
          </div>
          <Element name="rekomendasi-belajar" className="pb-6">
            <TopicRecommendationList
              isLoading={getTopicRecommendation.isLoading}
              items={getTopicRecommendation?.data?.data || []}
              isError={getTopicRecommendation.isError}
            />
          </Element>
          <Element name="progress-topik" className="pb-6">
            <TopicProgress
              isLoading={getTopicProgress.isLoading}
              selectedProgress={selectedProgress}
              isError={getTopicProgress.isError}
            />
          </Element>
          <Element name="webinar" className="pb-6">
            <TopicWebinar
              items={getWebinar?.data?.data?.webinar || []}
              isLoading={getWebinar.isLoading}
              isError={getWebinar.isError}
            />
          </Element>
          <div>
            <TopicMore />
          </div>
        </div>
      </div>
    </>
  )
}

export default ForYouRevamp
